import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '../lib/auth';
import { hasAnyRole, type RoleCode } from '../lib/types';

export function RoleGate({ roles, children }: { roles: RoleCode[]; children: ReactNode }) {
  const { user } = useAuth();
  return hasAnyRole(user, roles) ? children : <Navigate to="/" replace />;
}
